import type { ReactNode } from 'react';

import Backdrop from '@mui/material/Backdrop';

interface Props {
  readonly children: ReactNode;
  readonly enableBackdrop?: boolean;
}

export const Wrapper = ({
  children,
  enableBackdrop = true,
}: Readonly<Props>) =>
  enableBackdrop ? (
    <Backdrop
      open
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
    >
      {children}
    </Backdrop>
  ) : (
    <>{children}</>
  );
